import { SelectOption } from '../models';

export enum ProjectStatusEnum {
  // LEGACY
  ORDER_ENTRY = 'ORDER_ENTRY',
  PLAN_DONE = 'PLAN_DONE',
  PLAN_VALIDATED = 'PLAN_VALIDATED', // A garder
  ORDER_TO_BE_DELIVER = 'ORDER_TO_BE_DELIVER',
  TO_BE_INSTALLED = 'TO_BE_INSTALLED',
  TO_BE_INVOICED = 'TO_BE_INVOICED',
  INVOICED = 'INVOICED',

  // NEW
  DRAFT = 'DRAFT',
  SIZING_COMPLETED = 'SIZING_COMPLETED', // Calculation outputs available for review and export; ready for validation
}

/**
 * Utility to convert enum to label
 */
export class ProjectStatusHelper {
  private static readonly projectStatusLabelMap: Record<
    ProjectStatusEnum,
    string
  > = {
    [ProjectStatusEnum.ORDER_ENTRY]: 'Order Entry',
    [ProjectStatusEnum.PLAN_DONE]: 'Plan done',
    [ProjectStatusEnum.PLAN_VALIDATED]: 'Plan validated',
    [ProjectStatusEnum.ORDER_TO_BE_DELIVER]: 'Order to be delivered',
    [ProjectStatusEnum.TO_BE_INSTALLED]: 'To be installed',
    [ProjectStatusEnum.TO_BE_INVOICED]: 'To be invoiced',
    [ProjectStatusEnum.INVOICED]: 'Invoiced',
    [ProjectStatusEnum.DRAFT]: 'Draft',
    [ProjectStatusEnum.SIZING_COMPLETED]: 'Sizing completed',
  };

  /**
   * Convert ProjectStatusEnum enum to label translate key
   * @param status
   */
  static enumToLabelKey(status: ProjectStatusEnum): string {
    return this.projectStatusLabelMap[status] ?? '';
  }

  private static getConstantList(): ProjectStatusEnum[] {
    return [
      ProjectStatusEnum.ORDER_ENTRY,
      ProjectStatusEnum.PLAN_DONE,
      ProjectStatusEnum.PLAN_VALIDATED,
      ProjectStatusEnum.ORDER_TO_BE_DELIVER,
      ProjectStatusEnum.TO_BE_INSTALLED,
      ProjectStatusEnum.TO_BE_INVOICED,
      ProjectStatusEnum.INVOICED,
      ProjectStatusEnum.DRAFT,
      ProjectStatusEnum.SIZING_COMPLETED,
    ];
  }

  static getOptions(): SelectOption[] {
    return this.getConstantList().map((projectStatus) => ({
      label: this.enumToLabelKey(projectStatus),
      value: projectStatus,
    }));
  }
}
